import React from "react";

const kulturKartlari = [
  {
    ikon: "fa-music",
    baslik: "Horon",
    aciklama:
      "Karadeniz'in coşkusu ve dayanışma ruhunun simgesi olan horon, hızlı temposu, titreşimli adımları ve toplu oynanmasıyla Trabzon kültürünün en çarpıcı ifadesidir. Her etkinliğimizde yaşatmaya devam ediyoruz.",
    renk: "brand-bordo",
  },
  {
    ikon: "fa-guitar",
    baslik: "Kemençe",
    aciklama:
      "Karadeniz'in sesi olan kemençe; derin yaylanın özlemini, denizin hüznünü ve insanın sevincini aynı anda taşır. Usta kemençe sanatçılarımız bu geleneği kuşaktan kuşağa aktarmaktadır.",
    renk: "brand-blue",
  },
  {
    ikon: "fa-fish",
    baslik: "Hamsi Kültürü",
    aciklama:
      "Trabzon mutfağının vazgeçilmezi hamsi; pilav, ekmek, tava, buğulama ve daha pek çok farklı şekilde sofralara girer. Her yıl geleneksel Hamsi Günü etkinliğimizde bu lezzeti Bursa'ya taşıyoruz.",
    renk: "brand-gold",
  },
  {
    ikon: "fa-house",
    baslik: "Yöresel Mimari",
    aciklama:
      "Trabzon'un ahşap cumbalı evleri, taş işçiliğiyle bezeli hanları ve dağ köylerinin yaylaları; yüzyıllarca sürdürülen bir yaşam biçiminin mimari yansımasıdır. Bu miras, kolektif belleğimizin temel taşlarındandır.",
    renk: "brand-bordo",
  },
  {
    ikon: "fa-leaf",
    baslik: "Yayla Kültürü",
    aciklama:
      "Her yaz binlerce Trabzonlu, yüzyıllık gelenekle yaylalara çıkar. Karadeniz'in serin ve yeşil yaylalarında kurulan bu geçici kentler, insanlar arasındaki dayanışmanın en güzel örneğidir.",
    renk: "brand-blue",
  },
  {
    ikon: "fa-place-of-worship",
    baslik: "Tarihi Yapılar",
    aciklama:
      "Trabzon Ayasofyası, Sümela Manastırı, Ortahisar Kalesi ve Gülbahar Hatun Camii — her biri ayrı bir medeniyetin izlerini taşıyan bu yapılar, şehrin derin tarihinin yaşayan tanıklarıdır.",
    renk: "brand-gold",
  },
];

const colorMap: Record<string, string> = {
  "brand-gold": "#D4A017",
  "brand-blue": "#0F4C81",
  "brand-bordo": "#4E0F26",
};

const TrabzonKulturuPage: React.FC = () => (
  <div className="min-h-screen bg-bg-page">

    {/* Hero */}
    <div className="bg-gradient-to-br from-[#0F172A] to-[#1A2540] py-16 text-white">
      <div className="w-full px-6 xl:px-16 text-center">
        <div className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2">
          Tarihçe ve Hafıza
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3">Trabzon Kültürü</h1>
        <p className="text-white/70 max-w-2xl mx-auto leading-relaxed">
          Horondan kemençeye, hamsi sofrasından yaylalara — Karadeniz ruhunun yaşayan mirası.
        </p>
      </div>
    </div>

    {/* Kültür kartları */}
    <section className="py-16 bg-bg-page">
      <div className="w-full px-6 xl:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {kulturKartlari.map((kart) => (
            <div
              key={kart.baslik}
              className="card group hover:-translate-y-1 transition-transform border-t-4"
              style={{ borderTopColor: colorMap[kart.renk] }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-11 h-11 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: colorMap[kart.renk] + "20" }}
                >
                  <i
                    className={`fa-solid ${kart.ikon} text-lg`}
                    style={{ color: colorMap[kart.renk] }}
                  />
                </div>
                <h3 className="font-bold text-text-primary text-lg">{kart.baslik}</h3>
              </div>
              <p className="text-text-muted text-sm leading-relaxed text-justify">{kart.aciklama}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

  </div>
);

export default TrabzonKulturuPage;
